import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';

import logo from '../../img/logoproccess.png';
import logo2 from '../../img/logo.png';
import japon from '../../img/logo/japon.png';
import japonTextBlack from '../../img/logo/japon-text1.png';
import japonTextWhite from '../../img/logo/japon-text2.png';
import kanji2 from '../../img/logo/kanji2.png';


import {
    Nav,
    NavLogo,
    Logo,
    Image,
    MobileIcon,
    NavMenuContainer,
    NavMenu,
    NavItem,
    NavLinks,
    Container,
    NavbarMenu,
    MenuContainer,
    ArrowRight,
    NavBtn,
    LogoContainer,
    LogoText
} from './NavbarElements';

import { Button } from '../ButtonElement';
import FloatingWhatsApp from 'react-floating-whatsapp';

const Navbar = ({ toggle, isScroll }) => {
    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    }

    const toggleHome = () => {
        scroll.scrollToTop()
    }

    return (
        <>
            <IconContext.Provider value={{ size: '1.2em' }}>
                <Nav>
                    <NavbarMenu scroll={isScroll}>
                        <MenuContainer scroll={isScroll}>
                            <Container>
                                <NavLogo to='/' onClick={toggleHome}>
                                    <LogoContainer scroll={isScroll}>
                                        <Logo image={logo} image2={logo2} scroll={isScroll} />
                                    <LogoText scroll={isScroll}>Trusted Process Services</LogoText>
                                    </LogoContainer>
                                   
                                </NavLogo>

                            </Container>
                            <MobileIcon onClick={toggle}>
                                <FaBars />
                            </MobileIcon>

                            <NavMenuContainer>

                                <NavMenu>
                                   
                                    <NavItem>
                                        <NavLinks
                                            to="services"
                                            smooth={true}
                                            duration={500}
                                            spy={true}
                                            exact="true"
                                            offset={-50}
                                            activeClass="active">Our Services</NavLinks>
                                    </NavItem>
                                    {/* <NavItem>
                                        <NavLinks
                                            to="partners"
                                            smooth={true}
                                            duration={500}
                                            spy={true}
                                            exact="true"
                                            offset={-50}
                                            activeClass="active">Partners</NavLinks>
                                    </NavItem> */}
                                   

                                </NavMenu>

                                <NavBtn >
                                    <Button
                                        to="contact"
                                        smooth={true}
                                        duration={500}
                                        spy={true}
                                        exact="true"
                                        offset={-100}
                                        activeClass="active"
                                        scroll={isScroll?'true': 'false'}
                                    >
                                        Contact Us
                                    </Button>
                                </NavBtn>

                            </NavMenuContainer>
                        </MenuContainer>
                    </NavbarMenu>
                </Nav>
            </IconContext.Provider>
        </>
    )
}

export default Navbar
